<div class="heat-map" *ngIf="heatMap?.available">
  <div class="heat-map__stage" [style.aspect-ratio]="aspectRatio">
    <img class="heat-map__image" *ngIf="heatMap.image" [src]="heatMap.image" alt="Heat map" loading="lazy" />

    <svg class="heat-map__outlines" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <ng-container *ngFor="let node of heatMap.nodes; trackBy: trackByNodeId">
        <polygon *ngIf="node.polygon?.length" [attr.points]="points(node)" [ngClass]="'heat-map__outline--' + node.interest"></polygon>
      </ng-container>
    </svg>

    <button
      type="button"
      class="heat-map__node"
      *ngFor="let node of heatMap.nodes; trackBy: trackByNodeId"
      [ngClass]="['heat-map__node--' + node.interest, node.drill_to ? 'heat-map__node--drill' : '']"
      [style.left.%]="node.x"
      [style.top.%]="node.y"
      [style.--heat-size]="40 + node.score * 0.6 + 'px'"
      [disabled]="!node.drill_to"
      [attr.title]="node.label + ' · ' + node.views + ' views'"
      (click)="select(node)">
      <span class="heat-map__label">{{ node.label }}</span>
    </button>
  </div>

  <ul class="heat-map__legend" *ngIf="heatMap.legend?.length">
    <li *ngFor="let item of heatMap.legend">
      <i class="fa-solid fa-circle" [ngClass]="'heat-map__legend--' + item.key" aria-hidden="true"></i> {{ item.label }}
    </li>
  </ul>
</div>
